import Vue from 'vue'
import pluralize from 'pluralize'

Vue.filter('short', function (val) {
  val = val.length > 25 ? val.substring(0, 25) + "..." : val;
  return val
})

Vue.filter('price', function (val) {
  if (val === '') {
    return val
  }
  val = val !== 0 ? val / 100 : 0;
  val = val.toFixed(2)
  return `€ ${val}`
})

Vue.filter('money', function (val) {
  if (val === '' || val === undefined) {
    return ''
  }
  val = val !== 0 ? val / 100 : 0;
  val = val.toFixed(2)
  return `€ ${val}`
})

Vue.filter('pluralize', function (value, number) {
  return pluralize(value, number)
})

Vue.filter('time', function (timestamp) {
  if (!timestamp) {
    return ''
  }

  return new Date(timestamp).toLocaleDateString("lt-LT", {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  })
})

Vue.filter('nullableTime', function (timestamp) {
  if (timestamp) {
    return new Date(timestamp).toLocaleDateString("lt-LT", {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    })
  }
  return ""
})

Vue.filter('time_no_seconds', function (timestamp) {
  if (!timestamp) {
    return ''
  }

  return new Date(timestamp).toLocaleDateString("lt-LT", {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
})

Vue.filter('date', function (timestamp) {
  if (!timestamp) {
    return ''
  }

  let d = new Date(timestamp * 1000).toLocaleDateString(undefined, {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  })

  if (d === 'Invalid Date') {
    return timestamp
  }
  return d
})

Vue.filter('only_date', function (timestamp) {
  if (!timestamp) {
    return ''
  }

  let d = new Date(timestamp).toLocaleDateString("lt-LT", {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
  })

  if (d === 'Invalid Date') {
    return timestamp
  }
  return d
})

Vue.filter('bool', function (val) {
  if (val === true) {
    return '+'
  }

  if (val === false) {
    return '-'
  }

  return '?'
})

Vue.filter('trueFalse', function (val) {
  if (val === true) {
    return 'true'
  }
  return 'false'
})

Vue.filter('yesNo', function (val) {
  if (val === true) {
    return 'yes'
  }
  return 'no'
})

Vue.filter('int_bool', function (val) {
  if (val === 1) {
    return '+'
  }

  if (val === 0) {
    return '-'
  }

  return '?'
})


Vue.filter('dateOnly', function (timestamp) {
  if (!timestamp) {
    return ''
  }

  return new Date(timestamp).toLocaleDateString("lt-LT", {
    day: 'numeric',
    month: 'numeric',
    year: 'numeric'
    // hour: '2-digit',
    // minute: '2-digit',
    // second: '2-digit'
  })
})
